import React from 'react';
import Grid from '@material-ui/core/Grid';
import { WhiteSkeleton, useStyles } from './TakisSkeleton.styles';
import TakisDivider from '../TakisDivider';

const TakisHeroSkeleton = () => {
    const classes = useStyles();
      return (
        <>
        <div>
          <Grid container spacing={0} className={classes.gridContainer}>
            <Grid item xs={12} md={6} lg={7} className={classes.grid1}>
              <WhiteSkeleton variant="rect" className={classes.hero_bg}/>
            </Grid>
            <Grid item xs={12} md={6} lg={5} className={classes.grid2}>
            <div className={classes.hero_data}>
              <WhiteSkeleton variant="rect" className={classes.hero_heading}/>
              <WhiteSkeleton variant="rect" className={classes.hero_text}/>
              <WhiteSkeleton variant="rect" className={classes.center_button}/>
            </div>
            </Grid>
          </Grid>
        </div>
        <TakisDivider
        modifier={`${classes.slide_footer}`}
        marginModifier={`${classes.hero_divider_margin}`}
        variation={1}
        />
        </>
      );
}

export default TakisHeroSkeleton;
